import React from "react";
import { Lightbulb, Award, GraduationCap, Briefcase, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const pillars = [{
  title: "Entrepreneurship",
  description: "Fueling the ambitions of Hispanic business owners with capital, mentorship, and strategic resources to build sustainable enterprises.",
  icon: Lightbulb,
  href: "/programs"
}, {
  title: "Leadership Development",
  description: "Cultivating the next generation of civic and corporate leaders through immersive training and executive networking opportunities.",
  icon: Award,
  href: "/programs"
}, {
  title: "Youth & Education",
  description: "Bridging the opportunity gap for students with scholarships, internships, and career pathways that inspire future success.",
  icon: GraduationCap,
  href: "/programs"
}, {
  title: "Workforce Innovation",
  description: "Upskilling talent to meet the demands of a rapidly evolving economy, ensuring our community remains competitive and resilient.",
  icon: Briefcase,
  href: "/programs"
}];
export default function StrategicPillars() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="strategic-pillars" ref={ref} className={cn("w-full py-24 bg-background transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="w-full max-w-7xl mx-auto px-6">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold font-serif text-primary mb-6">
            Our Strategic Pillars
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            We focus our efforts on four key areas designed to create lasting economic impact and generational wealth for the Hispanic community in Colorado.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {pillars.map((pillar, i) => <Link key={i} to={pillar.href} className="block h-full group outline-none" data-index={i}>
              <Card className="h-full border border-transparent bg-white shadow-sm transition-all duration-300 hover:border-secondary hover:shadow-[0_4px_20px_-4px_var(--color-secondary)]/20 hover:-translate-y-1 relative overflow-hidden">
                <CardHeader className="pb-4">
                  <div className="mb-4 inline-flex items-center justify-center size-12 rounded-lg bg-secondary/10 text-secondary group-hover:bg-secondary group-hover:text-secondary-foreground transition-colors duration-300">
                    <pillar.icon className="size-6" />
                  </div>
                  <CardTitle className="text-2xl font-serif text-primary group-hover:text-secondary-foreground transition-colors">
                    {pillar.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex flex-col justify-between gap-6 h-full">
                  <CardDescription className="text-base text-muted-foreground leading-relaxed">
                    {pillar.description}
                  </CardDescription>
                  
                  <div className="flex items-center text-secondary font-medium text-sm mt-auto opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 ease-out">
                    Learn More <ArrowRight className="ml-2 size-4" />
                  </div>
                </CardContent>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}